const BASE_API = process.env.REACT_APP_ROUTE_API;
const token = localStorage.getItem('token');
const user = JSON.parse(localStorage.getItem('user'));
const headers = {Accept: 'application/json','Content-Type': 'application/json'};

export default {
    listar: async (tipoEvento) => {
        try {
          const req = await fetch(`${BASE_API}site/calendario/${tipoEvento}`, {
            method: 'GET',
            headers: headers
          });
          const json = await req.json();
                json.data = json.data ?? [];
                json.statusRetorno = req.status;
          return json;
        } catch (error) {
          return(error);
        }
      },
    listarAnterior: async (tipoEvento) => {
        try {
          const req = await fetch(`${BASE_API}site/calendario-anterior/${tipoEvento}`, {
            method: 'GET',
            headers: headers
          });
          const json = await req.json();
                json.data = json.data ?? [];
                json.statusRetorno = req.status;
          return json;
        } catch (error) {
          return(error);
        }
      },
    obterPorUrl: async (url) => {
      try {
        const req = await fetch(`${BASE_API}site/evento/${url}`, {
          method: 'GET',
          headers: headers
        });
        const json = await req.json();
              json.data = json.data ?? [];
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return(error);
      }
    },
    pagamento: async (data, token) => {
      try {
        let req;
          req = await fetch(`${BASE_API}site/evento/inscricao?token=` + token, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
          });
        const json = await req.json();
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return error;
      }
    },
    gerarPedidoCursoSeminario: async (data) => {
      try {
        let req;
          req = await fetch(`${BASE_API}site/evento/inscricao-candidato`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
          });
        const json = await req.json();
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return error;
      }
    },
    dadosInscricao: async (userId, eventoId, token) => {
      try {
        const req = await fetch(`${BASE_API}site/evento/inscricoes/${eventoId}/${userId}?token=` + token, {
          method: 'GET',
          headers: headers
        });
        const json = await req.json();
              json.data = json.data ?? [];
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return(error);
      }
    },
    pagamentoSemVinculo: async (data) => {
      try {
        let req;
          req = await fetch(`${BASE_API}site/evento/inscricao-sem-vinculo`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
          });
        const json = await req.json();
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return error;
      }
    },
    pagamentoSemVinculoDuplas: async (data) => {
      try {
        let req;
          req = await fetch(`${BASE_API}site/evento/inscricao-poomsae-duplas-sem-vinculo`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
          });
        const json = await req.json();
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return error;
      }
    },
    pagamentoSemVinculoTk3: async (data) => {
      try {
        let req;

        req = await fetch(`${BASE_API}site/evento/inscricao-gyeorugi-tk3-sem-vinculo`, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data)
        });

        const json = await req.json();
        json.statusRetorno = req.status;

        return json;
      } catch (error) {
        return error;
      }
    },
    obterInscritosPorIdModalidade: async (eventoId, modalidadeEvento) => {
      try {
        const req = await fetch(`${BASE_API}site/evento/inscritos/${eventoId}/${modalidadeEvento}`, {
          method: 'GET',
          headers: headers
        });
        const json = await req.json();
              json.data = json.data ?? [];
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return(error);
      }
    },
    obterEventoDesconto: async (userId, eventoId, valor, token) => {
      try {
        const req = await fetch(`${BASE_API}site/evento/desconto/${eventoId}/${userId}/${valor}?token=` + token, {
          method: 'GET',
          headers: headers
        });
        const json = await req.json();
              json.data = json.data ?? [];
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return(error);
      }
    },
};